<script>
export default {
  name: "ra-render",
  functional: true,
  render: (h, ctx) => {
    return ctx.props.render ? ctx.props.render(h, ctx.data.attrs) : h("div", "render error");
  }
}
</script>